<template>
  <div class="haircut py-3">
    <div class="container-fluid">
      <div class="row align-items-center home">
        <div class="col-md-6">
          <h1 class="welcome-msg m-0">WELCOME,</h1>
          <h1 class="welcome-msg m-0 mb-5">BARBER SHOP</h1>
          <!-- <p>Insert Arrow here</p> -->

          <div class="boxes mb-3" id="serving">
            <h1 class="m-0">Currently Serving:</h1>
            <p class="fw-bold">{{ currentValue }}</p>
          </div>
          <div class="boxes" id="queuing">
            <h1 class="m-0">Queuing:</h1>
            <p class="fw-bold">{{ queueValue }}</p>
          </div>
        </div>
        <div class="col-md-6">
          <p class="question display-1">What service are you after?</p>
          <div class="row home-card">
            <div v-for="data in services" :key="data.id" class="col-md-12 pb-3">
              <router-link
                class="text-decoration-none"
                :to="{
                  path: `/selected-service/${data.slug}`,
                }"
              >
                <div
                  class="card d-flex align-items-center justify-content-center"
                >
                  <img :src="data.image" alt="" />
                  <span class="m-0 text-white fw-bolder p-4 display-5">
                    {{ data.title }}
                  </span>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from "@/util/util";
export default {
  name: "Home",
  mounted() {
    this.bindEvent();
    this.getServiceList();
    this.getQueueCurrent();
  },
  data() {
    return {
      current: [],
      queue: [],
      services: [],
    };
  },
  methods: {
    bindEvent() {
      util.bindEvent.call(this, {
        channelName: "ChangeTokenStatus",
        eventName: "ChangeTokenStatus",
        callback: () => {
          this.getQueueCurrent();
        },
      });
    },
    getServiceList() {
      this.$http.get("/service/list").then((res) => {
        this.services = res.data;
      });
    },
    getQueueCurrent() {
      this.$http.get("/token/queue-current").then((res) => {
        // console.log(res.data.data);
        this.current = res.data.data.current;
        this.queue = res.data.data.queue;
        // this.$store.commit("setQueueCurrent", res.data);
      });
    },
  },
  computed: {
    currentValue: function () {
      let val = "";
      this.current.forEach((item) => {
        console.log("logging");
        console.log(item);
        val += item.token_number + ", ";
      });
      return val.replace(/,\s*$/, "");
    },
    queueValue: function () {
      let val = "";
      this.queue.forEach((item) => {
        console.log("logging");
        console.log(item);
        val += item.token_number + ", ";
      });
      return val.replace(/,\s*$/, "");
    },
  },
};
</script>
<style scoped>
.home {
  position: relative;
  z-index: 1;
}
.home .boxes {
  background: rgba(51, 51, 51, 0.5);
}
</style>
